module.exports = __webpack_public_path__ + "img/rf-kuang.b0a8c042.png";